export const USER_PROFILE_OPTIONS = {
  width: '600px',
  maxWidth: '95vw',
  panelClass: 'no-radius-dialog',
};
